import React from 'react';

var MentionContent = function MentionContent(_ref) {
  var children = _ref.children;
  return React.createElement(
    'span',
    { style: { backgroundColor: '#e6f3ff' } },
    children
  );
};

export default MentionContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-mention@1.1.1@rc-editor-mention/es/component/MentionContent.react.js
// module id = 803
// module chunks = 0 1